import { enqueueSnackbar } from 'notistack';
import { createAction } from 'redux-actions';

import { getMessage } from '@gef-ui/localization/messages';

import fetch from 'features/common/fetch';
import { setCampaignDetail } from 'features/views/campaignManagement/campaignDetail/actions';

import * as types from './actionTypes';
import { requestFactory } from './utils';

export const discardSeller = createAction(types.DISCARD_SELLER);
export const nominateSeller = createAction(types.NOMINATE_SELLER);
export const resetNominations = createAction(types.RESET_NOMINATIONS);
export const setNominatedSellers = createAction(types.SET_NOMINATED_SELLERS, (logins) => ({ logins }));

export const updateNominations = (campaignId, nominatedSellers) => (dispatch) => {
	dispatch(
		fetch.actions.put(fetch.constants.urls.campaignNominations, {
			uniqueReqID: 'put',
			replaceParams: {
				id: campaignId,
			},
			body: requestFactory(nominatedSellers),
			onSuccess: [
				() => () => {
					enqueueSnackbar(getMessage('toastr:approveNominationSave'), { variant: 'success' });
				},
			],
		}),
	);
};

export const fetchNominatedSellers = (campaignId, channel, region, agency, manager, seller) => (dispatch) => {
	return dispatch(
		fetch.actions.get(fetch.constants.urls.campaignNominations, {
			uniqueReqID: 'get',
			replaceParams: {
				id: campaignId,
			},
			queryParams: {
				channelId: channel,
				regionId: region,
				agencyIds: [agency],
				manager,
				seller,
			},
		}),
	);
};

export const fetchNominationsCount = (campaignId, queryParams, uniqueReqID) => (dispatch) => {
	return dispatch(
		fetch.actions.get(fetch.constants.urls.campaignNominationsCount, {
			uniqueReqID,
			replaceParams: {
				id: campaignId,
			},
			queryParams,
		}),
	).then((response) => {
		const layerByIds = {};
		response.body.forEach((layer) => {
			layerByIds[layer.layerId] = layer.count;
		});
		return layerByIds;
	});
};

export const fetchCampaignDetail = (campaignId) => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.campaignDetailWithoutConsideringRole, {
			replaceParams: { id: campaignId },
			onSuccess: [
				(response) => () => {
					const data = response.body;
					if (!data) return;
					dispatch(setCampaignDetail(data));
				},
			],
		}),
	);
};
